import React from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { languages } from "../../constants/languages";
import Checkbox from "@material-ui/core/Checkbox";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import NewPlayerScoreButton from "./NewPlayerScoreButton";
import StarsIcon from "@material-ui/icons/Stars";
import DeleteIcon from "@material-ui/icons/Delete";
import withMobileDialog from "@material-ui/core/withMobileDialog";
import { FormControlLabel } from "@material-ui/core";

class SubmitResultFullscreen extends React.Component {
  state = {
    step: 0,
    goalSelected: null,
    clearConfirmation: false,
    showButtons: true,
  };

  toggleButtons = () => {
    this.setState({ showButtons: !this.state.showButtons });
  };

  confirmClear = () => {
    this.setState({ clearConfirmation: true });
  };

  selectGoal = (e, i) => {
    this.setState({ goalSelected: i });
  };

  handleChange = (event, step) => {
    this.setState({ step });
  };

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    if (this.props.open !== nextProps.open && nextProps.open === true) {
      let playerPresent = false;
      for (let i in this.props.players) {
        let p = this.props.players[i];
        if ((p.matches || []).indexOf(this.props.match.id) !== -1) {
          playerPresent = true;
          break;
        }
      }
      if (
        (playerPresent && (this.props.playerGoals || []).length > 0) ||
        Object.keys(this.props.tournament.playerPoints || {}).find((p) => {
          return this.props.tournament.playerPoints[p].type === "3";
        }) === undefined
      ) {
        this.setState({ step: 1 });
      } else {
        this.setState({ step: 0 });
      }
    }
  };

  UNSAFE_componentWillMount = () => {
    let playerPresent = false;
    for (let i in this.props.players) {
      let p = this.props.players[i];
      if ((p.matches || []).indexOf(this.props.match.id) !== -1) {
        playerPresent = true;
        break;
      }
    }
    if (
      playerPresent ||
      Object.keys(this.props.tournament.playerPoints || {}).find((p) => {
        return this.props.tournament.playerPoints[p].type === "3";
      }) === undefined
    ) {
      this.setState({ step: 1 });
    }
  };

  render() {
    let players1 = this.props.players
      .filter((p) => p.team === this.props.team1Id)
      .sort((a, b) =>
        a.name.localeCompare(b.name, undefined, {
          numeric: true,
          sensitivity: "base",
        })
      );

    let players2 = this.props.players
      .filter((p) => p.team === this.props.team2Id)
      .sort((a, b) =>
        a.name.localeCompare(b.name, undefined, {
          numeric: true,
          sensitivity: "base",
        })
      );

    let players1Present = players1.filter(
      (player) => (player.matches || []).indexOf(this.props.match.id) !== -1
    );

    let players2Present = players2.filter(
      (player) => (player.matches || []).indexOf(this.props.match.id) !== -1
    );

    if (
      Object.keys(this.props.tournament.playerPoints || {}).find((p) => {
        return this.props.tournament.playerPoints[p].type === "3";
      }) === undefined
    ) {
      players1Present = players1;
      players2Present = players2;
    }

    let playerGoalsMatch = this.props.playerGoalsMatch.slice().reverse();

    let showLastStep = false;
    if (Object.keys(this.props.tournament.customPoints || {}).length > 0) {
      showLastStep = true;
    } else if (
      Object.keys(this.props.tournament.playerPoints || {}).filter((key) => {
        let points = this.props.tournament.playerPoints[key];
        if (key !== "0" && points.type !== "3") {
          return true;
        } else {
          return false;
        }
      }).length > 0
    ) {
      showLastStep = true;
    } else if (this.props.showPenalties) {
      showLastStep = true;
    } else if (this.props.showCheckboxes) {
      showLastStep = true;
    }

    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.toggleDialog}
        aria-labelledby="form-dialog-title"
        disableBackdropClick
        disableEscapeKeyDown
        maxWidth="xl"
        fullScreen={this.props.fullScreen}
        style={{ height: "100%" }}
      >
        <DialogTitle id="form-dialog-title">
          {languages.results.submitResult}
          <IconButton
            style={{ float: "right" }}
            color="inherit"
            onClick={(e) => {
              this.setState({ clearConfirmation: false });
              this.props.toggleDialog(e);
            }}
            aria-label="Close"
          >
            <CloseIcon />
          </IconButton>{" "}
        </DialogTitle>
        {this.props.missingTeams &&
        this.props.match.score1 === null &&
        this.props.match.score2 === null ? (
          <DialogContent>
            {this.props.fase === 0
              ? languages.formatString(
                  languages.results.missingTeamsWarning,
                  this.props.tournament.individualPlayers
                    ? languages.teams.playersLow
                    : languages.tournament.teamsLow
                )
              : languages.results.startFaseFirst}
          </DialogContent>
        ) : (
          <DialogContent style={{ fontFamily: "roboto", height: 500 }}>
            <div>
              <table
                style={{
                  width: "100%",
                  background: "rgb(236, 239, 241)",
                  fontSize: "20px",
                  borderRadius: 5,
                  padding: 5,
                  tableLayout: "fixed",
                  marginBottom: 10,
                  textAlign: "center",
                }}
              >
                <tbody>
                  <tr>
                    <td
                      style={{
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        maxWidth: 1,
                      }}
                    >
                      {this.props.team1}
                    </td>
                    <td>
                      {this.state.step === 0
                        ? this.props.startTime
                        : this.props.goals1 + " - " + this.props.goals2}
                    </td>
                    <td
                      style={{
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        maxWidth: 1,
                      }}
                    >
                      {this.props.team2}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            {this.state.step === 0 && (
              <div style={{ width: "100%" }}>
                <div
                  style={{
                    width: "100%",
                    textAlign: "center",
                    marginTop: 20,
                    marginBottom: 20,
                  }}
                >
                  {languages.results.selectPresentPlayers}
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    width: "100%",
                    maxWidth: 800,
                    margin: "auto",
                  }}
                >
                  <div style={{ marginBottom: 40 }}>
                    {players1.map((player) => (
                      <div
                        key={player.id}
                        style={{
                          height: 40,
                          paddingLeft: 15,
                          display: "flex",
                          alignItems: "center",
                          width: 250,
                          justifyContent: "space-between",
                        }}
                      >
                        <div>
                          {player.name +
                            (player.number ? ` (${player.number})` : "")}
                        </div>
                        <Checkbox
                          checked={
                            (player.matches || []).indexOf(
                              this.props.match.id
                            ) !== -1
                          }
                          onClick={(e) => {
                            this.props.handlePlayerPresentCheck(
                              e,
                              player,
                              this.props.match.id
                            );
                          }}
                          color="primary"
                        />
                      </div>
                    ))}
                  </div>
                  <div>
                    {players2.map((player) => (
                      <div
                        key={player.id}
                        style={{
                          height: 40,
                          paddingLeft: 15,
                          display: "flex",
                          alignItems: "center",
                          width: 250,
                          justifyContent: "space-between",
                        }}
                      >
                        <div>
                          {player.name +
                            (player.number ? ` (${player.number})` : "")}
                        </div>
                        <Checkbox
                          checked={
                            (player.matches || []).indexOf(
                              this.props.match.id
                            ) !== -1
                          }
                          onClick={(e) => {
                            this.props.handlePlayerPresentCheck(
                              e,
                              player,
                              this.props.match.id
                            );
                          }}
                          color="primary"
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
            {this.state.step === 1 && (
              <div style={{ width: "100%" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: 20,
                    marginBottom: 20,
                    margin: "auto",
                  }}
                >
                  {this.state.showButtons && (
                    <NewPlayerScoreButton
                      goals1={true}
                      submitNewGoal={this.props.submitNewGoal}
                      label={languages.results.goal}
                      players={players1Present}
                    />
                  )}
                  <Fab
                    onClick={this.toggleButtons}
                    color="primary"
                    aria-label="add"
                    style={{ margin: "10px" }}
                    size="small"
                  >
                    <AddIcon />
                  </Fab>
                  {this.state.showButtons && (
                    <NewPlayerScoreButton
                      goals2={true}
                      submitNewGoal={this.props.submitNewGoal}
                      label={languages.results.goal}
                      players={players2Present}
                    />
                  )}
                </div>
                {(this.props.playerGoals || [])
                  .slice()
                  .reverse()
                  .map((g, i) => {
                    let player = this.props.playersByKey[g] || {};
                    return (
                      <div
                        key={i}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          margin: "auto",
                          height: 60,
                        }}
                      >
                        {player.team === this.props.team1Id ||
                        g === "ownGoal1" ? (
                          <div
                            style={{
                              fontSize: 17,
                              width: 300,
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "end",
                            }}
                          >
                            <div
                              style={{
                                fontWeight: 500,
                              }}
                            >
                              {(playerGoalsMatch[i] || "").slice(
                                1,
                                (playerGoalsMatch[i] || "").length - 1
                              )}
                            </div>
                            <div
                              style={{
                                textOverflow: "ellipsis",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                maxWidth: "34vw",
                              }}
                            >
                              {g === "ownGoal1"
                                ? languages.results.ownGoal
                                : (player.name || "") +
                                  (player.number ? ` (${player.number})` : "")}
                            </div>
                          </div>
                        ) : (
                          <div style={{ width: 300 }} />
                        )}
                        <div style={{ width: 60, textAlign: "center" }}>
                          {this.state.goalSelected === i ? (
                            <DeleteIcon
                              onClick={(e) => {
                                this.selectGoal(e, null);
                                this.props.deleteGoal(e, i);
                              }}
                              style={{
                                color: "#d50000",
                                height: 30,
                                width: 30,
                                cursor: "pointer",
                                marginLeft: 10,
                                marginRight: 10,
                              }}
                            />
                          ) : (
                            <StarsIcon
                              onClick={(e) => {
                                this.selectGoal(e, i);
                              }}
                              style={{
                                color: "gray",
                                height: 30,
                                width: 30,
                                cursor: "pointer",
                                marginLeft: 10,
                                marginRight: 10,
                              }}
                            />
                          )}
                        </div>
                        {player.team === this.props.team2Id ||
                        g === "ownGoal2" ? (
                          <div
                            style={{
                              fontSize: 17,
                              width: 300,
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "start",
                            }}
                          >
                            <div
                              style={{
                                fontWeight: 500,
                              }}
                            >
                              {(playerGoalsMatch[i] || "").slice(
                                1,
                                (playerGoalsMatch[i] || "").length - 1
                              )}
                            </div>
                            <div
                              style={{
                                textOverflow: "ellipsis",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                maxWidth: "34vw",
                              }}
                            >
                              {g === "ownGoal2"
                                ? languages.results.ownGoal
                                : (player.name || "") +
                                  (player.number ? ` (${player.number})` : "")}
                            </div>
                          </div>
                        ) : (
                          <div style={{ width: 300 }} />
                        )}
                      </div>
                    );
                  })}
              </div>
            )}
            {this.state.step === 2 && (
              <div style={{ width: "100%" }}>
                <div
                  style={{
                    width: 300,
                    margin: "20px auto",
                  }}
                >
                  {languages.results.endResult}
                </div>
                {this.props.showCheckboxes && (
                  <div style={{ width: 300, margin: "20px auto" }}>
                    <div>{languages.results.markWinner}</div>
                    <div>
                      <div>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name={this.props.match.team1.toString()}
                              checked={
                                this.props.winner ===
                                this.props.match.team1.toString()
                              }
                              onClick={this.props.handleCheck}
                              color="primary"
                            />
                          }
                          label={this.props.team1}
                        />
                      </div>
                      <div>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name={this.props.match.team2.toString()}
                              checked={
                                this.props.winner ===
                                this.props.match.team2.toString()
                              }
                              onClick={this.props.handleCheck}
                              color="primary"
                            />
                          }
                          label={this.props.team2}
                        />
                      </div>
                    </div>
                  </div>
                )}
                {this.props.showPenalties && (
                  <div style={{ width: 300, margin: "auto" }}>
                    <div style={{ fontWeight: "bold" }}>
                      {languages.results.penaltyShootout}
                    </div>
                    <TextField
                      margin="dense"
                      label={
                        (this.props.team1 || "").length > 30
                          ? this.props.team1.substr(0, 30 - 1) + "..."
                          : this.props.team1
                      }
                      value={
                        this.props.penalties1 !== null
                          ? this.props.penalties1
                          : ""
                      }
                      name="penalties1"
                      onChange={this.props.handlePenaltiesChange}
                      type="number"
                      inputProps={{ inputMode: "numeric" }}
                      style={{ width: "100%" }}
                      onKeyDown={this.handleKeyDown}
                    />
                    <TextField
                      margin="dense"
                      label={
                        (this.props.team2 || "").length > 30
                          ? this.props.team2.substr(0, 30 - 1) + "..."
                          : this.props.team2
                      }
                      value={
                        this.props.penalties2 !== null
                          ? this.props.penalties2
                          : ""
                      }
                      name="penalties2"
                      onChange={this.props.handlePenaltiesChange}
                      type="number"
                      inputProps={{ inputMode: "numeric" }}
                      style={{ width: "100%" }}
                      onKeyDown={this.handleKeyDown}
                    />
                  </div>
                )}
                <div style={{ width: 300, margin: "auto" }}>
                  {Object.keys(this.props.tournament.customPoints || {})
                    .length > 0 && (
                    <div>
                      {/* <div style={{ fontWeight: "bold" }}>
                    {languages.structure.morePoints}
                  </div> */}
                      {Object.keys(
                        this.props.tournament.customPoints || {}
                      ).map((key) => {
                        let customPoints =
                          this.props.tournament.customPoints[key];
                        return (
                          <div key={key} style={{ marginTop: 15 }}>
                            <div style={{ fontWeight: "bold" }}>
                              {customPoints.name}
                            </div>
                            <TextField
                              margin="dense"
                              label={
                                (this.props.team1 || "").length > 25
                                  ? this.props.team1.substr(0, 25 - 1) + "..."
                                  : this.props.team1
                              }
                              value={this.props.extra1[key] || ""}
                              name={key}
                              onChange={(e) => {
                                this.props.handleExtraChange(e, 1);
                              }}
                              type="number"
                              inputProps={{ inputMode: "numeric" }}
                              style={{ width: 300 }}
                            />
                            <br />
                            <TextField
                              margin="dense"
                              label={
                                (this.props.team2 || "").length > 25
                                  ? this.props.team2.substr(0, 25 - 1) + "..."
                                  : this.props.team2
                              }
                              value={this.props.extra2[key] || ""}
                              name={key}
                              onChange={(e) => {
                                this.props.handleExtraChange(e, 2);
                              }}
                              type="number"
                              inputProps={{ inputMode: "numeric" }}
                              style={{ width: 300 }}
                            />
                          </div>
                        );
                      })}
                    </div>
                  )}

                  {Object.keys(this.props.tournament.playerPoints || {}).map(
                    (key) => {
                      let points = this.props.tournament.playerPoints[key];
                      if (key !== "0" && points.type !== "3") {
                        return (
                          <div key={key} style={{ marginTop: 30 }}>
                            <div style={{ fontWeight: "bold" }}>
                              {points.name}
                            </div>
                            {(this.props.playerPoints[key] || []).map(
                              (g, i) => {
                                return (
                                  <FormControl key={i} style={{ marginTop: 7 }}>
                                    <InputLabel shrink htmlFor={"points" + i}>
                                      {points.abbr +
                                        " " +
                                        (points.type !== "2" ? i + 1 : "")}
                                    </InputLabel>
                                    <Select
                                      style={{ width: 300 }}
                                      value={g}
                                      onChange={(e) => {
                                        this.props.handlePlayerPointsChange(
                                          e,
                                          key
                                        );
                                      }}
                                      inputProps={{
                                        name: i.toString(),
                                        id: "points" + i,
                                      }}
                                    >
                                      <MenuItem value={""}>
                                        <i>{languages.general.delete}</i>
                                      </MenuItem>
                                      {players1Present
                                        .concat(players2Present)
                                        .sort((a, b) =>
                                          a.name.localeCompare(
                                            b.name,
                                            undefined,
                                            {
                                              numeric: true,
                                              sensitivity: "base",
                                            }
                                          )
                                        )
                                        .map((player) => (
                                          <MenuItem
                                            key={player.id}
                                            value={player.id}
                                          >
                                            {player.name +
                                              (player.number
                                                ? ` (${player.number})`
                                                : "") +
                                              " - " +
                                              (player.team ===
                                              this.props.team1Id
                                                ? this.props.team1
                                                : this.props.team2)}
                                          </MenuItem>
                                        ))}
                                    </Select>
                                  </FormControl>
                                );
                              }
                            )}

                            {(points.type !== "2" ||
                              (this.props.playerPoints[key] || []).length <
                                1) && (
                              <FormControl style={{ marginTop: 7 }}>
                                <InputLabel shrink htmlFor="points">
                                  {points.abbr +
                                    " " +
                                    (points.type !== "2"
                                      ? (this.props.playerPoints[key] || [])
                                          .length + 1
                                      : "")}
                                </InputLabel>
                                <Select
                                  style={{ width: 300 }}
                                  value={""}
                                  onChange={(e) => {
                                    this.props.handlePlayerPointsChange(e, key);
                                  }}
                                  inputProps={{
                                    name: "new",
                                    id: "points",
                                  }}
                                >
                                  {players1Present
                                    .concat(players2Present)
                                    .sort((a, b) =>
                                      a.name.localeCompare(b.name, undefined, {
                                        numeric: true,
                                        sensitivity: "base",
                                      })
                                    )
                                    .map((player) => (
                                      <MenuItem
                                        key={player.id}
                                        value={player.id}
                                      >
                                        {player.name +
                                          (player.number
                                            ? ` (${player.number})`
                                            : "") +
                                          " - " +
                                          (player.team === this.props.team1Id
                                            ? this.props.team1
                                            : this.props.team2)}
                                      </MenuItem>
                                    ))}
                                </Select>
                              </FormControl>
                            )}
                          </div>
                        );
                      } else {
                        return null;
                      }
                    }
                  )}
                </div>
              </div>
            )}
          </DialogContent>
        )}
        <DialogActions>
          {((this.props.match.score1 !== null &&
            this.props.match.score2 !== null) ||
            Object.keys(this.props.sets).length > 0) && (
            <Button
              onClick={(e) => {
                if (this.state.clearConfirmation) {
                  this.props.handleSubmit(e, true);
                } else {
                  this.confirmClear();
                }
              }}
              color="secondary"
            >
              {this.state.clearConfirmation
                ? languages.tournament.areYouSure
                : languages.results.clearResult}
            </Button>
          )}
          <Button
            onClick={
              this.state.step === 0 ||
              (this.state.step === 1 &&
                Object.keys(this.props.tournament.playerPoints || {}).find(
                  (p) => {
                    return this.props.tournament.playerPoints[p].type === "3";
                  }
                ) === undefined)
                ? (e) => {
                    this.setState({ clearConfirmation: false });
                    this.props.toggleDialog(e);
                  }
                : (e) => {
                    this.handleChange(e, this.state.step - 1);
                  }
            }
            color="primary"
          >
            {this.state.step === 0 ||
            (this.state.step === 1 &&
              Object.keys(this.props.tournament.playerPoints || {}).find(
                (p) => {
                  return this.props.tournament.playerPoints[p].type === "3";
                }
              ) === undefined)
              ? languages.general.close
              : languages.general.back}
          </Button>
          {this.state.step === 0 || (this.state.step === 1 && showLastStep) ? (
            <Button
              onClick={(e) => {
                this.handleChange(e, this.state.step + 1);
              }}
              variant="contained"
              color="primary"
              type="submit"
            >
              {languages.general.continue}
            </Button>
          ) : (
            <Button
              onClick={(e) => {
                this.setState({ clearConfirmation: false });
                this.props.handleSubmit(
                  e,
                  false,
                  this.props.goals1,
                  this.props.goals2
                );
              }}
              disabled={
                this.props.submitDisabled ||
                (this.props.missingTeams &&
                  this.props.match.score1 !== null &&
                  this.props.match.score2 !== null &&
                  this.props.score1 !== null &&
                  this.props.score2 !== null)
              }
              variant="contained"
              color="primary"
              type="submit"
            >
              {languages.formatString(
                languages.results.submitFinalResult,
                this.props.goals1.toString() +
                  " - " +
                  this.props.goals2.toString()
              )}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    );
  }
}

export default withMobileDialog()(SubmitResultFullscreen);
